import React from 'react';
import AddElementButton from "../product_elements/AddElementButton";
import ElementStepByStep from "../product_elements/ElementStepByStep";
import ElementSummary from "../product_elements/ElementSummary";
import ElementShapeOptionalStep from "../product_elements/ElementShapeOptionalStep";
import AddElementSectionButton from "../product_elements/AddElementSectionButton";
import ImportElements from "../product_elements/ImportElements";
import GeneratedShapeElements from "../product_elements/GeneratedShapeElements";
import SummaryLoader from "../loaders/SummaryLoader";


const ProductElementsStep = () => {
    return (
        <div className="row">
            <div className="configurator-count">
                <div style={{position: 'relative'}}>
                    <div className="configurator-step elements-wrapper" >
                        <ImportElements />
                        <div className="row elements">
                            <ElementShapeOptionalStep />
                            <ElementStepByStep />
                        </div>
                        <AddElementButton />
                    </div>
                </div>
            </div>
            <ElementSummary />
            <SummaryLoader />
        </div>
    );
}

export default ProductElementsStep;